import { ReactElement, useMemo } from 'react';

import { useActionInput } from '../../../';
import { Privacy } from '../types';
import { usePrivacyOptions } from './use-privacy-options';

export interface VisibilityOption {
	description: string;
	icon: ReactElement;
	label: string;
	value: Privacy;
}

export const usePrivacy = () => {
	const { privacy, privacyButtonEnabled } = useActionInput();
	const options = usePrivacyOptions();

	const selectedOption = useMemo(() => {
		return options.find((option) => option.value === privacy) || options[0];
	}, [options, privacy]);

	return {
		options,
		selectedOption,
		buttonEnabled: privacyButtonEnabled,
	};
};
